import React from "react";
import {Flex} from "@chakra-ui/react";
import {Version} from "./Version";
import {Title} from "./Title";

interface Props {
    forClient: string;
    normalURL: string;
    goldURL: string;
}

export const VersionPicker = React.memo<Props>(({ forClient, normalURL, goldURL }) => {
    return (
        <Flex p={{ base: 4, md: 16 }} minH="100vh" flexDirection="column" alignItems="center" backgroundImage={require("./asset/background.jpg")} backgroundPosition="center center" backgroundRepeat='repeat' backgroundSize="cover">
            <Title forClient={forClient} />
            <Flex flexDirection={{ base: 'column', md: 'row' }}>
                <Version url={normalURL} title="自家豬腳薑醋卡" imageSrc={require("./asset/normal.jpg")} />
                <Version url={goldURL} title="至尊豬腳小黃薑醋禮卡" imageSrc={require("./asset/gold.jpg")} />
            </Flex>
        </Flex>
    );
});
